import gql from 'graphql-tag';

export const archiveEscalationRule = gql`
  mutation archiveEscalationRule($escalationRuleId: UUID!) {
    archiveEscalationRule(escalationRuleId: $escalationRuleId)
  }
`;
